import filter from "lodash/filter";
import { ProfileCustomValue, SkillsFrameworkSkill } from "PFCore/types";

export const canTagSkillsAs = (
  tag: "top" | "developmental",
  profileSkills: ProfileCustomValue[],
  selectedSkills: (ProfileCustomValue | SkillsFrameworkSkill)[],
  limit: number
) => {
  const taggedSkillsCount = filter(profileSkills, tag).length;
  const selectedTaggedSkillsCount = filter(selectedSkills, tag).length;
  const newTaggedSkillsCount = selectedSkills.length - selectedTaggedSkillsCount;

  return newTaggedSkillsCount === 0 || taggedSkillsCount + newTaggedSkillsCount <= limit;
};
